export function Panel({ children, className = "" }) {
  return (
    <div className={`bg-stone-950/70 border border-amber-900/30 rounded-3xl p-4 backdrop-blur-sm ${className}`}>
      {children}
    </div>
  );
}

export function NightPanel({ children, className = "" }) {
  return (
    <div className={`bg-indigo-950/80 border border-indigo-800/30 rounded-3xl p-4 backdrop-blur-sm ${className}`}>
      {children}
    </div>
  );
}

export function SectionTitle({ children }) {
  return (
    <p className="text-xs uppercase tracking-[0.15em] text-amber-600/70 font-semibold mb-3">
      {children}
    </p>
  );
}

export function NightHeader({ night, t }) {
  return (
    <div className="flex items-center justify-between mb-4">
      <div>
        <h2 className="text-indigo-200 font-bold text-lg">
          🌙 {t(`Nuit ${night}`, `Night ${night}`)}
        </h2>
        <p className="text-indigo-400/60 text-xs">{t("Le village dort…", "The village sleeps…")}</p>
      </div>
    </div>
  );
}

export function DayHeader({ day, t }) {
  return (
    <div className="flex items-center justify-between mb-4">
      <div>
        <h2 className="text-amber-300 font-bold text-lg">
          ☀️ {t(`Jour ${day}`, `Day ${day}`)}
        </h2>
        <p className="text-amber-600/60 text-xs">{t("Le village se réveille…", "The village awakens…")}</p>
      </div>
    </div>
  );
}
